<div class="container-fluid">
    <div class="row">
      <div class="col-xl-12">
        <h1 class="page-hd">Dashboard</h1>
        <div class="content-wrap">
          <div class="col-md-3">
            <h2>Please Select Year</h2>
            <select formControlName="collegenameid" class="form-control form-input" (change)="getDataByYear($event.target.value)">
                <option value="undefined" disabled> Please select Year </option>
                <option *ngFor="let data of yearList" [ngValue]="data.finYear" [selected]="data.finYear == currentYear">
                  {{data.finYear}}</option>
            </select>
          </div>
            <h1 class="page-hd">General Summary</h1>
              <div class="table-responsive">
                <table class="ui celled table hover" id="generalSummary" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th>Pending</th>
                      <th>Closed</th>
      
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of overAllSummary">
                      <td>{{data.month}}</td>
                      <td>{{data.pending}}</td>
                      <td>{{data.closed}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
        <div class="col-xl-12">
          <h1 class="page-hd">Ageing Summary</h1>
          <div class="content-wrap">
            <div class="table-responsive">
              <table class="ui celled table hover" id="ageingSummary" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>0 - 30 Days</th>
                    <th>31 - 60 Days</th>
                    <th>60 Days & Above</th>
    
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of ageingSummary">
                    <td>{{data.month}}</td>
                    <td>{{data.lessthan}}</td>
                    <td>{{data.inbetween}}</td>
                    <td>{{data.above}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
  </div>
  <!-- <div class="modal fade" id="viewModal" #viewModalBox tabindex="-1" role="dialog" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
          <button type="button" #closebutton class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <p class="doc-txt">To be verified</p>
              <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)">
              <div *ngIf="isVrPdf">
                <div class="ng-star-inserted22">
                  <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
                </div>
                <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
              </div>
              <div *ngIf="isVrImage">
                <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy">
              </div>
            </div>
            <div class="col-md-6">
              <p class="doc-txt">System document</p>
              <div *ngIf="isUPdf">
                <div class="ng-star-inserted22">
                  <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
                </div>
                <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
              </div>
              <div *ngIf="isUImage">
                <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy">
              </div>
            </div>
          </div>
          <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved"
            (click)="changeStatus($event)">Positive</button>
          <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Pass"
            (click)="changeStatus($event)">Match and Pass</button>
          <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Fail"
            (click)="changeStatus($event)">Match and Fail</button>
          <button class="reject-modal-btn mr-auto" data-toggle="modal" name="UN_Rejected" data-target="#rejectModal"
            (click)="openRemarkModal($event)">Negative</button>
            <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Ver_Request_Edit" data-target="#editReasonModal"
            (click)="fetchEditReason($event)">Send To edit</button>
        </div>
      </div>
    </div>
  </div> -->
  
  <!-- <ng-template #showModalBoxImage let-modal>
    <div class="modal-content">
      <div class="modal-header bg-theme">
        <h5 class="modal-title" id="viewModalLabel">Preview Document</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div *ngIf="!isVrPdf && !noImage1">
              <app-magnify [imageId]="imgname" [ImageURL]="upload_doc_path"> </app-magnify>
            </div>
  
            <p class="doc-txt">To be verified</p>
            <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)">
            <div *ngIf="isVrPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isVrImage">
              <img src={{upload_doc_path}} class="doc-img" (click)="showLightbox(0)" loading="lazy">
  
              <div class="img-magnifier-container">
                <img src={{upload_doc_path}} class="doc-img" id="uploadImg1" (click)="showLightbox(0)" loading="lazy">
              </div>
  
            </div>
          </div>
          <div class="col-md-6">
            <div *ngIf="!isUPdf && !noImage2">
              <app-magnify [imageId]="imgname2" [ImageURL]="originalDocUploadFilePath"> </app-magnify>
            </div>
            <p class="doc-txt">System document</p>
            <div *ngIf="isUPdf">
              <div class="ng-star-inserted22">
                <pdf-viewer [src]="src1" [zoom]="1"></pdf-viewer>
              </div>
              <button class="new-tab-btn" (click)="openPdf1()">Open Doc in Browser</button>
            </div>
            <div *ngIf="isUImage">
              <img src={{originalDocUploadFilePath}} class="doc-img" (click)="showLightbox(1)" loading="lazy">
              <div class="img-magnifier-container">
                <img src={{originalDocUploadFilePath}} class="doc-img" id="uploadImg2" (click)="showLightbox(1)"
                  loading="lazy">
              </div>
            </div>
          </div>
        </div>
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved"
          (click)="changeStatus($event)">Positive</button>
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Pass"
          (click)="changeStatus($event)">Match and Pass</button>
        <button class="approve-modal-btn bg-theme mr-auto" data-dismiss="modal" name="UN_Approved_Fail"
          (click)="changeStatus($event)">Match and Fail</button>
        <button class="reject-modal-btn mr-auto" data-toggle="modal" name="UN_Rejected" data-target="#rejectModal"
          (click)="openRemarkModal($event)">Negative</button>
          <button class="approve-modal-btn bg-theme mr-auto" data-toggle="modal" name="Ver_Request_Edit" data-target="#editReasonModal"
          (click)="fetchEditReason($event)">Send To edit</button>
      </div>
    </div>
  
  </ng-template>
  
  <div class="modal fade" id="editReasonModal" tabindex="-1" role="dialog" aria-labelledby="editReasonModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="editReasonModalLabel">Reason For Edit</h5>
          <button type="button" #closebuttonRemark class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="EditReasonForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group input-group-lg">
                  <label for="editReasonVal" class="form-label">Edit Reason<span class="color-red">*</span></label>
                  <textarea placeholder="Enter your reason" [(ngModel)]="editReasonVal" class="form-control form-input"
                    id="editReasonVal" formControlName="editReasonVal"
                    [ngClass]="{'is-invalid': submitted4 && i.editReasonVal.errors }"></textarea>
                  <div *ngIf="submitted4 && i.editReasonVal.errors" class="invalid-feedback">
                    <div *ngIf="i.editReasonVal.errors.required">Reason is required</div>
                  </div>
                </div>
  
  
              </div>
            </div>
          </form>
          <button class="approve-modal-btn bg-theme mr-auto" name="Ver_Request_Edit"
            (click)="changeEditStatusWithReason($event)">Submit</button>
          <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
  
  
  <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="rejectModalLabel">Remark</h5>
          <button type="button" #closebuttonRemark class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="RemarkForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group input-group-lg">
  
                  <label for="reasonVal" class="form-label">Remark<span class="color-red">*</span></label>
                  <textarea placeholder="Enter your remark" [(ngModel)]="reasonVal" class="form-control form-input"
                    id="reasonVal" formControlName="reasonVal"
                    [ngClass]="{'is-invalid': submitted && f.reasonVal.errors }"></textarea>
                  <div *ngIf="submitted && f.reasonVal.errors" class="invalid-feedback">
                    <div *ngIf="f.reasonVal.errors.required">Remark is required</div>
                  </div>
  
                </div>
              </div>
            </div>
          </form>
          <button class="approve-modal-btn bg-theme mr-auto" name="UN_Rejected"
            (click)="changeRemarkStatus($event)">Submit</button>
          <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div> -->
  
  <!-- <ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
  
    <div class="modal-content">
      <div class="modal-header success-modal-header">
        <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
          <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
  
        </h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <h3 class="success-text">Success</h3>
            <p class="reset-hd2">Status has been updated.</p>
          </div>
        </div>
        <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
      </div>
    </div>
  </ng-template> -->
  
  <!-- <div class="modal fade" id="remarkDetails" tabindex="-1" role="dialog" aria-labelledby="remarkModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-theme">
          <h5 class="modal-title" id="remarkModalLabel">Remark Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group input-group-lg">
                <span class="appId">{{remark}} </span>
              </div>
            </div>
          </div>
  
          <form [formGroup]="NewRemarkForm">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group input-group-lg">
  
                  <label for="newReasonVal" class="form-label">Remark</label>
                  <textarea placeholder="Enter your comment" [(ngModel)]="newReasonVal" class="form-control form-input"
                    id="newReasonVal" formControlName="newReasonVal"></textarea>
                </div>
              </div>
            </div>
          </form>
          <button class="approve-modal-btn bg-theme mr-auto"
            (click)="addNewRemark($event)" data-dismiss="modal">Submit</button>
          <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
  
        </div>
      </div>
    </div>
  </div> -->
  
<!--   
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>
  
  <ng-image-fullscreen-view [images]="imageObject" [imageIndex]="selectedImageIndex" [show]="showFlag"
    (close)="closeEventHandler()">
  </ng-image-fullscreen-view> -->